/**
 * The ONE geometry of the upload & processing screen — every instance, both
 * clients, a full screen or a pane alike (founder, 2026-10-20: "same size,
 * layout, same gap"). A container smaller than this centres the stage; it
 * never shrinks Ka. Pinned by `ProcessingStage.spec.tsx`.
 */
export const PROCESSING_STAGE_LAYOUT = {
  /** Prof. Ka's card edge (px / pt). His peeks overflow it sideways. */
  kaSize: 96,
  /** Between every row: Ka · title (+ subtitle) · bar · pro tip · actions. */
  gap: 16,
  /** Between the title and its subtitle. */
  titleGap: 8,
  /** The title, the bar and the pro tip never run wider than this. */
  maxWidth: 360,
  /** Inset around the stage inside its container. */
  paddingX: 24,
  paddingY: 24,
} as const;
